import {
  GET_EVENT_FS_OBJECT_CHILDREN,
  GET_ARCHIVED_EVENT_FS_OBJECTS
} from 'actions/Types';

export default (state = true, action) => {
  if (
    action.type === GET_EVENT_FS_OBJECT_CHILDREN ||
    action.type === GET_ARCHIVED_EVENT_FS_OBJECTS
  ) {
    return true;
  }

  if (
    action.type === `${GET_EVENT_FS_OBJECT_CHILDREN}_SUCCESS` ||
    action.type === `${GET_ARCHIVED_EVENT_FS_OBJECTS}_SUCCESS` ||
    action.type === `${GET_EVENT_FS_OBJECT_CHILDREN}_FAILURE` ||
    action.type === `${GET_ARCHIVED_EVENT_FS_OBJECTS}_FAILURE`
  ) {
    return false;
  }

  return state;
};
